// Point d'entrée de la carte : chargé uniquement sur les pages qui l'affichent
// (accueil, résidences, fiche résidence). Reprend l'instance Stimulus de l'application.
import CarteController from "./controllers/carte_controller"

window.Stimulus.register("carte", CarteController)
